import script from "./SouthboundOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./SouthboundOverview.vue?vue&type=script&setup=true&lang=js"

import "./SouthboundOverview.vue?vue&type=style&index=0&id=494c5768&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-494c5768"]])

export default __exports__